import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from '../../../../../../app/config/axiosInstance';
import { AxiosResponse } from 'axios';
import URLs from '../../../../../../utils/appURLs';
import { updateToast } from '../../../../../../common/redux/reducer/commonSlices/toastSlice';

type ReturnedType = any;

const initialStateDropDown = {
  isLoading: false,
  data: null,
  error: null
};

interface AutoGeneratedTripState {
  isLoading: boolean;
  data: any | null;
  error: string | null;
}

const initialState: AutoGeneratedTripState = {
  isLoading: false,
  data: null,
  error: null
};

//Action for IMEI Dropdown
export const imeiDropdownAction = createAsyncThunk<AxiosResponse<any>, any>(
  'imeiDropdown',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.IMEI_DROPDOWN}?vehicleNumber=${data?.vehicleNumber}`
      });
      return response?.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for IMEI dropdown
const imeiDropdownSlice = createSlice({
  name: 'imeiDropdown',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(imeiDropdownAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        imeiDropdownAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload.data;
          state.error = null;
        }
      )
      .addCase(imeiDropdownAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for SIM Dropdown
export const simDropdownAction = createAsyncThunk<AxiosResponse<any>, any>(
  'simDropdown',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.SIM_DROPDOWN}?vehicleNumber=${data?.vehicleNumber}`
      });
      return response?.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for SIM dropdown
const simDropdownSlice = createSlice({
  name: 'simDropdown',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(simDropdownAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        simDropdownAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload.data;
          state.error = null;
        }
      )
      .addCase(simDropdownAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for planID Dropdown
export const planIdDropdownAction = createAsyncThunk<any>(
  'planIdDropdown',
  async (_, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.PLAN_ID_DROPDOWN}`
      });
      return response?.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for planID dropdown
const PlanIdDropdownSlice = createSlice({
  name: 'planIdDropdown',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(planIdDropdownAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        planIdDropdownAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload.data;
          state.error = null;
        }
      )
      .addCase(planIdDropdownAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for vehicleMake Dropdown
export const vehicleMakeDropdownAction = createAsyncThunk<any>(
  'vehcileMakeDropdown',
  async (_, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.VEHICLE_MAKE_DROPDOWN}`
      });
      return response?.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for planID dropdown
const vehicleMakeDropdownSlice = createSlice({
  name: 'vehicleMakeDropdown',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(vehicleMakeDropdownAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        vehicleMakeDropdownAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload.data;
          state.error = null;
        }
      )
      .addCase(vehicleMakeDropdownAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for vehicleModel Dropdown
export const vehicleModelDropdownAction = createAsyncThunk<AxiosResponse<any>, any>(
  'vehcileModelDropdown',
  async (data, thunkApi) => {
    const { vehicleMake, vehicleModel, manufacturedyear } = data;
    const queryParams: Record<string, string | number | boolean | undefined> = {
      vehiclemake: vehicleMake,
      vehiclemodel: vehicleModel,
      manufacturedyear: manufacturedyear
    };
    const filteredParams = Object.entries(queryParams)
      .filter(
        ([key, value]) =>
          value !== undefined && value !== null && value !== '' && !Number.isNaN(value)
      )
      .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
      .join('&');
    try {
      const response = await axiosInstance({
        method: 'GET',

        url: `${URLs.VEHICLE_MODEl_DROPDOWN}&${filteredParams}`
      });
      return response?.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for planID dropdown
const vehicleModelDropdownSlice = createSlice({
  name: 'vehicleMakeDropdown',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(vehicleModelDropdownAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        vehicleModelDropdownAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload.data;
          state.error = null;
        }
      )
      .addCase(vehicleModelDropdownAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for Add Vehicle
export const vehicleOnboardAction = createAsyncThunk<ReturnedType, any>(
  'vehcileOnboard',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: `${URLs.ADD_VEHICLE}`,
        data
      });

      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response?.data?.data[0];
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.response.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for vehicle Onboard
const vehicleOnboardSlice = createSlice({
  name: 'vehcileOnboard',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(vehicleOnboardAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        vehicleOnboardAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action?.payload?.data;
          state.error = null;
        }
      )
      .addCase(vehicleOnboardAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for Update Vehicle
export const vehicleUpdateAction = createAsyncThunk<ReturnedType, any>(
  'vehcileUpdate',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'PUT',
        url: `${URLs.UPDATE_VEHICLE}`,
        data
      });

      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response?.data?.data[0];
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.response.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for vehicle Update
const vehicleUpdateSlice = createSlice({
  name: 'vehcileUpdate',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(vehicleUpdateAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        vehicleUpdateAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action?.payload?.data;
          state.error = null;
        }
      )
      .addCase(vehicleUpdateAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

//Action for Deactivate Driver
export const deactivateVehicleAction = createAsyncThunk<ReturnedType, any>(
  'deactive/vehicle',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'PATCH',
        url: `${URLs.DEACTIVATE_VEHICLE}vehicleNumber=${data}`
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response.data?.message,
          severity: 'success'
        })
      );
      return response?.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') {
        thunkApi.dispatch(
          updateToast({
            show: true,
            message: error?.response?.data?.message,
            severity: 'error'
          })
        );
      }

      return thunkApi.rejectWithValue(error);
    }
  }
);

// slice for Deactivate Driver
const deactivateVehicleSlice = createSlice({
  name: 'vehicleDeactivate',
  initialState: initialStateDropDown,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(deactivateVehicleAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        deactivateVehicleAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action?.payload?.data;
          state.error = null;
        }
      )
      .addCase(deactivateVehicleAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error;
      });
  }
});

// Action function to delete vehicle
export const vehicleDeleteAction = createAsyncThunk<ReturnedType, any>(
  'auto-planner-vehicle/delete',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'DELETE',
        url: `${URLs.DELETE_VEHICLE}vehicleNumber=${data?.vehicleNumber}`
      });

      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response?.data?.data;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error.response.data?.error,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

// delete auto planner vehicle slice
const deleteVehicleSlice = createSlice({
  name: 'auto planner vehicle delete',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(vehicleDeleteAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        vehicleDeleteAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload?.data;
          state.error = null;
        }
      )
      .addCase(vehicleDeleteAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data?.error || 'Something went wrong';
      });
  }
});

export const deactivateVehicle = deactivateVehicleSlice.reducer;
export const dropIMEI = imeiDropdownSlice.reducer;
export const vehicleDelete = deleteVehicleSlice.reducer;
export const vehiUpdate = vehicleUpdateSlice.reducer;
export const vehicleOnboardAdd = vehicleOnboardSlice.reducer;
export const vehicleModel = vehicleModelDropdownSlice.reducer;
export const dropSIM = simDropdownSlice.reducer;
export const planID = PlanIdDropdownSlice.reducer;
export const vehicleMake = vehicleMakeDropdownSlice.reducer;
